import { Terminal } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

/**
 * Shown instead of the app when web/.env.local is missing or incomplete. Without it the Firebase
 * SDK cannot even be initialised, and a blank page would be the only symptom.
 */
export function SetupScreen({ missing }: { missing: string[] }) {
  return (
    <main className="flex min-h-svh items-center justify-center p-6">
      <Card className="w-full max-w-xl">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Terminal className="size-5" />
            Firebase не настроен
          </CardTitle>
          <CardDescription>
            Создайте файл <code>web/.env.local</code> по образцу <code>web/.env.example</code> и
            перезапустите <code>npm run dev</code>.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <p className="text-muted-foreground">Не заданы переменные:</p>
          <ul className="list-inside list-disc font-mono text-xs">
            {missing.map((key) => (
              <li key={key}>{key}</li>
            ))}
          </ul>
          <p className="text-muted-foreground text-xs">
            Значения берутся в Firebase Console → Project settings → Your apps → Web app → SDK setup
            and configuration → Config.
          </p>
        </CardContent>
      </Card>
    </main>
  )
}
